/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import './App.scss';
import './Styles/bootstrap.min.css';
import './Styles/styles.scss';
import { useDispatch, useSelector } from 'react-redux';
import Error from 'Screens/Error';
import { validateSession } from 'Screens/Login/actions/Actions';
import { selectLocation } from 'store/Router/selectors';
import { selectIsLoggedIn, selectIsValidatingSession } from 'store/Sesion/selectors';
import { setUrlReturn } from 'Screens/Contextualization/Faraday/actions/Actions';
import errorHandler from './Common/Handlers/ErrorHandler';
import FileUploadContext from './Common/Components/FileUploadContext';
import LicenseValidator from './Common/Components/LicenseValidator';
import RedirectModal from './Common/Components/RedirectModal';
import { Content, Wrapper } from './styled';

import { initialize, trackPageView } from './tracking/GA';
import { selectShowProcessingQueue } from 'store/FileUploaderContext/selector';
import SpinnerComponent from 'Common/Components/SpinnerContainer';
import NavMenuContext from 'Screens/Contextualization/NavMenu';
import SideBarContext from 'Screens/Contextualization/Sidebar';
import TabsContext from 'Screens/Contextualization/Tabs';
import CommandValidator from 'Common/Components/CommandValidator';
import ModalsController from 'Common/Components/ModalController';
import { ShortcutProvider } from 'Context/Shortcut';
import ShortcutsHelp from 'Common/Components/ShortcutsHelp';
import TwoFactorSuccessNotice from 'Screens/Contextualization/Settings/components/Account/components/TwoFactor/components/TwoFactorSuccessNotice';

const noLayoutRoutes = [
  '/login',
  '/forgotpass',
  '/resetpass',
  '/verify-email'
];

const App = ({ logOut, children }) => {
  const gaKey = useSelector(() => (process.env.REACT_APP_GA_MEASUREMENT));
  const location = useSelector(selectLocation);
  const isValidatingSession = useSelector(selectIsValidatingSession);
  const showImportModal = useSelector(selectShowProcessingQueue);
  const loggedIn = useSelector((state) => selectIsLoggedIn(state));
  const dispatch = useDispatch();
  const [mounted, setMounted] = useState(false);

  const hideLayout = noLayoutRoutes.some(route =>
    location.pathname.startsWith(route)
  );

  useEffect(() => {
    dispatch(initialize(gaKey));
    dispatch(validateSession());
    errorHandler(logOut);
    setMounted(true);
  }, [dispatch]);

  useEffect(() => {
    dispatch(trackPageView(`${location.pathname}${location.search}`));
    if (location.hash.startsWith('#/status/ws/')) dispatch(setUrlReturn(location.hash.replace('#/status/ws/', 'manage/')));
    else if (!noLayoutRoutes.some(route => location.pathname.startsWith(route))) dispatch(setUrlReturn(location.pathname));
  }, [dispatch, location]);

  if (!mounted) return null;
  if (isValidatingSession) return <SpinnerComponent height="100%" />;

  if (hideLayout || !loggedIn) {
    return <>{children}</>;
  }

  return (
  <ShortcutProvider>
    <Wrapper>
      <NavMenuContext />
      <SideBarContext />
      <TabsContext />
      <Content>
        {children}
        <ModalsController />
      </Content>
      <LicenseValidator />
      <RedirectModal />
      <Error />
      <TwoFactorSuccessNotice />
      {(showImportModal && loggedIn) && <FileUploadContext />}
      <CommandValidator />
      <ShortcutsHelp />
    </Wrapper>
  </ShortcutProvider>
  );
};

export default App;
